module.exports = __webpack_public_path__ + "img/ch-101-el.asm.6bb353d7.jpg";